/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser; permissions?: string[] } | undefined,
) {
  const { currentUser, permissions } = initialState ?? {};

  /**
   * 检查用户是否拥有指定权限
   * @param permission 权限标识
   */
  const hasPermission = (permission: string): boolean => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.includes(permission);
  };

  // 与后端 SecurityUtils.isPlatformAdmin() 对齐:userId=1 超管 或 userType="00" 平台管理员
  // JWT 字段(user_id / user_type)由 LoginServiceImpl 写入
  const isPlatformAdmin =
    !!currentUser &&
    (Number(currentUser.user_id) === 1 || currentUser.user_type === '00');

  return {
    canAdmin: isPlatformAdmin,
    isPlatformAdmin,
    hasPermission,
  };
}
